/* eslint-disable react/display-name */
import { memo } from 'react';

import { lazyLoad } from 'utils/loadable';

import { AdministrationRouting } from './taxes.routing';
export const TaxesComponent = memo(() => {
  return (
    <>
      <AdministrationRouting />
    </>
  );
});

export const TaxesModule = lazyLoad(
  () => import('./taxes.module'),
  (module) => module.TaxesComponent
);
